/**
 * The sign-in page's word on a Shopify return it is standing in front of.
 *
 * A reinstall started from the Shopify admin (or finished in another browser)
 * comes back with the store already connected, but with no BuzzBit session in
 * this browser — so the success landing is carried to /login as `?redirect=`.
 * The form alone read as "the connection failed and logged me out"; this says
 * which store is waiting and that signing in finishes the job. Same look as
 * the signup page's handoff notice (pages/signup/ShopifyHandoffNotice).
 */
import type { ReactElement } from 'react';
import { t } from '../../i18n';
import { shopifyReturnIn } from '../../lib/shopifyReturn';

interface Props {
  /** The already-sanitised same-site path the sign-in will continue to. */
  redirectTo: string;
}

export function ShopifyReconnectNotice({ redirectTo }: Props): ReactElement | null {
  const store = shopifyReturnIn(redirectTo);
  if (!store) return null;
  return (
    <div role="status" className="mb-6 p-3 bg-emerald-50 border border-emerald-200 rounded-lg">
      <p className="text-sm text-emerald-800">
        {t('integrations.handoff.reconnectSignIn', {
          store: store.name || store.shop || t('integrations.handoff.yourStore'),
        })}
      </p>
    </div>
  );
}
